import { checkUserLoggedIn } from "../store/actions/authAction";
import { setGlobalLoader } from "../store/actions/loaderAction";
import { LOCALSTORAGE_KEY } from "../utils/Constants";
function CheckUserFromOAuth(dispatch: any) {
  try {
    dispatch(setGlobalLoader(true));
    let userDataFromSession: any = localStorage.getItem(LOCALSTORAGE_KEY.USERINFO);
    let parsedUserData: any = null;
    if (
      userDataFromSession &&
      userDataFromSession !== "undefined" &&
      userDataFromSession !== "null"
    ) {
      parsedUserData = JSON.parse(userDataFromSession);
    }
    if (parsedUserData?.id) {
      dispatch(setGlobalLoader(true));
      dispatch(checkUserLoggedIn(parsedUserData.phoneNumber))
        .then((result: any) => {})
        .catch((error: any) => {
          console.log("Not resolved user info");
        });
      // dispatch(checkUserDetails("+917278091832"))
    } else {
      dispatch(setGlobalLoader(false));
    }
  } catch (error) {
    console.log("Error:", error);
  } finally {
    dispatch(setGlobalLoader(false));
  }
}

export default CheckUserFromOAuth;
